// extracted by mini-css-extract-plugin
module.exports = {"form":"SimpleForm_form__3FDcd","p15":"SimpleForm_p15__DKCNx","p20":"SimpleForm_p20__2ha15"};